import React from "react";
import {message, Select} from "antd";
import {OptionProps} from "antd/lib/select";
import "../DynamicForm.scss";
import {ComboElementProps} from "@data-force/app";
import {connect} from "react-redux";
import {SPACE_KEY} from "../../../utils/constants";
import {clearAlerts} from "../../../store/actions/layout";
import {ClearAlertsAction} from "../../../interfaces/store/actions/layout";

interface DispatchProps {
    clearAlerts(): ClearAlertsAction
}

export type Props = ComboElementProps & DispatchProps;

class ComboElement extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

        this.singleSelectHandler = this.singleSelectHandler.bind(this);
        this.filterOption = this.filterOption.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.getPopupContainer = this.getPopupContainer.bind(this);
    }

    getPopupContainer(trigger: HTMLElement): HTMLElement {
        return trigger.parentNode as HTMLElement;
    }

    /**
     * Default SPACE_KEY behavior, causes page scroll and display of empty option list.
     *
     * @param {React.KeyboardEvent} event
     * @return {void}
     */
    handleKeyDown(event: React.KeyboardEvent): void {
        if (event.key === SPACE_KEY) {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    singleSelectHandler(value: string | number): void {
        const {
            fieldName, index, refElements, onSave,
        }: ComboElementProps = this.props;
        this.props.onSelect({
            fieldName, value, index, refElements,
        });

        if (onSave) {
            onSave({
                fieldName,
                index,
                changeValue: value,
            });
        }
        message.destroy();
        this.props.clearAlerts();
    }

    /**
     * Used to make combo filter case insensitive.
     *
     * @param {string} input
     * @param {any} option
     * @return {boolean}
     */
    // TODO: create df option object
    filterOption(input: string, option: any): boolean {
        return !!option
            && option.children
            && typeof option.children.toLowerCase === "function"
            && option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }

    render() {
        const {
            value, allowedValues, className = "", readOnly,
        }: ComboElementProps = this.props;

        return (
            <Select
                className={className}
                value={value}
                onSelect={this.singleSelectHandler}
                disabled={readOnly}
                showSearch
                filterOption={this.filterOption}
                onKeyDown={this.handleKeyDown}
                getPopupContainer={this.getPopupContainer}
            >
                {
                    allowedValues?.map((allowedValue: string, optionIndex: number)
                    : React.ReactElement<OptionProps> => (
                        <Select.Option
                            key={`${optionIndex}-${allowedValue}`}
                            value={allowedValue}
                        >
                            {allowedValue}
                        </Select.Option>
                    ))
                }
            </Select>
        );
    }
}

const mapDispatchToProps: DispatchProps = {
    clearAlerts,
};

export default connect(null, mapDispatchToProps)(ComboElement);
